import React, { useState } from 'react';
import { X, Loader2, Send } from 'lucide-react';
import { BACKEND_URL } from './promoCart';
import { getVisit } from '../../lib/promoAttribution';
import { trackMeta, newEventId, metaContext } from '../../lib/metaPixel';

const FIELDS = [['name', 'Nom *'], ['company', 'Entreprise (facultatif)'], ['email', 'E-mail *'], ['phone', 'Téléphone *'], ['quantity', 'Quantité souhaitée']];

export const OfferRequestModal = ({ offer, offers, onClose }) => {
  const [f, setF] = useState({ name: '', company: '', email: '', phone: '', quantity: '', message: '', offer_slug: offer?.slug || '' });
  const [state, setState] = useState({ sending: false, error: '', number: '' });
  const submit = async () => {
    if (!f.name.trim() || !f.email.trim() || f.phone.trim().length < 4) { setState({ ...state, error: 'Nom, e-mail et téléphone sont obligatoires.' }); return; }
    setState({ sending: true, error: '', number: '' });
    const eventId = newEventId();
    try {
      const r = await fetch(`${BACKEND_URL}/api/promo-offers/request`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...f, quantity: f.quantity ? parseInt(f.quantity, 10) : null, attribution: getVisit()?.attribution, visit_id: getVisit()?.visit_id, meta: metaContext(eventId) }),
      });
      const d = await r.json();
      if (!r.ok) throw new Error(typeof d.detail === 'string' ? d.detail : 'Vérifiez les champs (e-mail valide).');
      trackMeta('Lead', { content_name: "Demande d'offre", content_ids: f.offer_slug ? [f.offer_slug] : undefined, currency: 'CHF' }, eventId);
      setState({ sending: false, error: '', number: d.number });
    } catch (e) { setState({ sending: false, error: e.message, number: '' }); }
  };
  const cls = 'h-11 px-3 bg-zinc-900 border border-zinc-700 rounded-lg text-white text-sm placeholder-zinc-500 focus:border-amber-500 outline-none w-full';
  return (
    <div className="fixed inset-0 z-[65] flex items-center justify-center p-3" data-testid="offer-request-modal">
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={onClose} />
      <div className="relative w-full max-w-md bg-zinc-950 border border-zinc-800 rounded-2xl p-5 space-y-3 max-h-[92vh] overflow-y-auto">
        <div className="flex items-center justify-between"><h3 className="text-lg font-bold text-white">Demander une offre</h3>
          <button onClick={onClose} className="w-11 h-11 flex items-center justify-center text-zinc-400 hover:text-white" data-testid="offer-request-close"><X className="w-5 h-5" /></button></div>
        {state.number ? (
          <p className="text-emerald-300 text-sm" data-testid="offer-request-success">Merci ! Demande n° {state.number} bien reçue. Un accusé de réception vous a été envoyé par e-mail, nous vous répondons rapidement.</p>
        ) : (
          <>
            <p className="text-xs text-zinc-400">Plus grande quantité, prix de projet ou autres conditions de paiement : sans création de compte.</p>
            <select value={f.offer_slug} onChange={(e) => setF({ ...f, offer_slug: e.target.value })} className={cls} data-testid="offer-request-offer">
              <option value="">Offre concernée…</option>{offers.map((o) => <option key={o.slug} value={o.slug}>{o.name}</option>)}
            </select>
            {FIELDS.map(([k, l]) => <input key={k} placeholder={l} type={k === 'email' ? 'email' : k === 'quantity' ? 'number' : 'text'} min={k === 'quantity' ? 1 : undefined}
              value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} className={cls} data-testid={`offer-request-${k}`} />)}
            <textarea rows={3} placeholder="Message" value={f.message} onChange={(e) => setF({ ...f, message: e.target.value })} className={`${cls} h-auto py-2`} data-testid="offer-request-message" />
            {state.error && <p className="text-sm text-red-400" data-testid="offer-request-error">{state.error}</p>}
            <button onClick={submit} disabled={state.sending} className="w-full h-12 bg-amber-500 text-black rounded-lg font-bold hover:bg-amber-400 disabled:opacity-40 flex items-center justify-center gap-2" data-testid="offer-request-submit">
              {state.sending ? <Loader2 className="w-5 h-5 animate-spin" /> : <Send className="w-5 h-5" />} Envoyer la demande
            </button>
          </>
        )}
      </div>
    </div>
  );
};
